// GathrXR Studio desktop bridge.
//
// This module wires the Electron shell's native menu commands to the web
// builder. It is imported once from src/index.tsx and is a TOTAL no-op in a
// normal browser: every side effect is gated behind `window.gathrxrDesktop`,
// which only the desktop preload (contextBridge) ever defines.
//
// The desktop app exposes:
//   window.gathrxrDesktop = { version, platform, onMenuCommand(cb) }
// and the WorldBuilder page publishes save/capture handlers on:
//   window.__gathrxrSaveWorld, window.__gathrxrCaptureThumbnail

type MenuCommand = 'save' | 'capture-thumbnail' | 'dashboard';

interface GathrxrDesktop {
  version: string;
  platform: string;
  onMenuCommand(cb: (command: MenuCommand) => void): void;
}

export function initDesktopBridge(): void {
  const desktop = (window as any).gathrxrDesktop as GathrxrDesktop | undefined;
  if (!desktop) return; // Browser: nothing to do.

  const runSave = () => {
    (window as any).__gathrxrSaveWorld?.();
  };

  // Route native menu commands to the builder.
  desktop.onMenuCommand((command) => {
    switch (command) {
      case 'save':
        runSave();
        break;
      case 'capture-thumbnail':
        (window as any).__gathrxrCaptureThumbnail?.();
        break;
      case 'dashboard':
        window.location.href = '/dashboard';
        break;
      default:
        break;
    }
  });

  // Bind Cmd/Ctrl+S inside the page to the same save hook (desktop only).
  window.addEventListener(
    'keydown',
    (e) => {
      if ((e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey && (e.key === 's' || e.key === 'S')) {
        e.preventDefault();
        runSave();
      }
    },
    { capture: true }
  );
}
